import React from "react";
import moment from "moment";

const ReconcileAllDates = (props) => {
    const {themeColor1, onSelectDate} = props;

    // Generate last 30 days
    const getLast30Days = () => {
        const days = [];
        for (let i = 0; i < 30; i++) {
            days.push(moment().subtract(i, 'days'));
        }
        return days;
    };

    const days = getLast30Days();

    return (
        <div className="reconcile-days-list">
            <h4>Select a day to reconcile:</h4>
            <div className="list-group">
                {days.map((day, index) => (
                    <div key={index} className="list-group-item d-flex justify-content-between align-items-center">
                        <span>{day.format('MMMM D, YYYY (dddd)')}</span>
                        <button
                            className="sos-custom-btn sos-custom-btn-css"
                            style={{
                                backgroundColor: themeColor1,
                                color: '#fff'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#fff';
                                e.target.style.color = themeColor1;
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = themeColor1;
                                e.target.style.color = '#fff';
                            }}
                            onClick={() => onSelectDate(day)}
                        >
                            Reconcile
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReconcileAllDates;
